import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import _ from 'lodash';
const firebaseRef = firebase.database();

export default async function getFloorplanImages(
	modelName,
	elevation,
	callback
) {
	firebaseRef
		.ref(
			'/kavtek_buildingInfo/' +
				PROJECT_CODE.projectCode +
				'/' +
				modelName +
				'/priceList/'
		)
		.once('value', (snapshot) => {
			var priceListObj = snapshot.val();
			var priceListObjKeys = _.keys(priceListObj);
			var keyFound;

			_.forEach(priceListObjKeys, function (key) {
				var elevationId = priceListObj[key].id;
				if (elevationId.toLowerCase() === elevation.toLowerCase()) {
					keyFound = key;
				}
			});
			var foundObject = priceListObj?.[keyFound];

			var floorplanFilesArray = foundObject?.['floorplanFiles'];

			var urls = _.map(
				floorplanFilesArray,
				(floorplanFile) => floorplanFile.url
			);
			callback(urls);
		});
}
